import { NgClass } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, ElementRef, Inject, OnInit, ViewChild, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { UnitCustomerTokenDataService, UnitCustomerTokenType } from '../../../../services/shared/unit-customer-token-data.service';
import { LoaderComponent } from '../../../loader/loader.component';

export interface CheckDepositDialogData {
  unitBankAccountId: string;
  unitCustomerId: string;
}

@Component({
  selector: 'terra-unit-check-deposit',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [LoaderComponent, NgClass],
  styleUrl: './unit-check-deposit.component.scss',
  templateUrl: './unit-check-deposit.component.html'
})
export class UnitCheckDepositComponent implements OnInit {
  @ViewChild("checkDeposit") checkDepositRef: ElementRef;
  @ViewChild('checkDepositFrame') checkDepositFrame!: ElementRef<HTMLIFrameElement>;

  customerToken = '';
  unitAccountId = '';
  isLoading = signal(true);
  stylesLoaded = signal(false);

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: CheckDepositDialogData,
    private unitCustomerTokenDataService: UnitCustomerTokenDataService,
  ) {}

  ngOnInit(): void {
    this.unitAccountId = this.data.unitBankAccountId;
    
    this.unitCustomerTokenDataService.getCustomerToken(
      this.data.unitCustomerId,
      { tokenTypes: [UnitCustomerTokenType.CheckDeposits] }
    )
      .pipe(take(1))
      .subscribe(token => {
        this.customerToken = token;
        this.isLoading.set(false);
      });
  }

  setNoonce(): void {
    const nonce = 'CSP_STYLE_NONCE_PLACEHOLDER';
    const shadowRoot = this.checkDepositRef?.nativeElement?.shadowRoot;

    if (!shadowRoot) return;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === 'STYLE') {
            (node as HTMLElement).setAttribute('nonce', nonce);
          }
        });
      }
        this.stylesLoaded.set(true);
    });

    observer.observe(shadowRoot, { childList: true });

    shadowRoot.querySelectorAll('style:not([nonce])').forEach((el: HTMLStyleElement) => {
      const clone = document.createElement('style');
      clone.setAttribute('nonce', nonce);
      clone.textContent = el.textContent;
      el.replaceWith(clone);
    });
    this.stylesLoaded.set(true);
  }

  unitOnLoad(event: Event): void {
    setTimeout(() => {
      this.setNoonce();
    }, 1000); // Delay to ensure the shadow DOM is ready
  }
}
